module.exports = __webpack_public_path__ + "static/media/one-in-korean.18a2cdbc.jpg";